import { render, staticRenderFns } from "./grade.vue?vue&type=template&id=bca63140&scoped=true&"
import script from "./grade.vue?vue&type=script&lang=js&"
export * from "./grade.vue?vue&type=script&lang=js&"
import style0 from "./grade.vue?vue&type=style&index=0&id=bca63140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca63140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\taiqiu\\back-end\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bca63140')) {
      api.createRecord('bca63140', component.options)
    } else {
      api.reload('bca63140', component.options)
    }
    module.hot.accept("./grade.vue?vue&type=template&id=bca63140&scoped=true&", function () {
      api.rerender('bca63140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/firm/grade.vue"
export default component.exports